import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB7-JOB1/src/components/DatePicker/DatePickerCalendarContainer.js",
  _this = this,
  _templateObject,
  _templateObject2,
  _templateObject3,
  _templateObject4;
import React from 'react';
import styled, { css } from 'styled-components';
import { BackArrow as BackArrowIcon } from '@dls/assets/icons';
import Button from '../Button';
import TextLink from '../TextLink';
import { withTheme } from '../../core/ThemeProvider';
import { noop } from '../../helpers';
import useDevice from '../../core/hooks/useDevice';
import { getStyledText } from '../../helpers/styled';
import Config from '../../config';
var DatePickerCalendarContainer = function DatePickerCalendarContainer(_ref) {
  var children = _ref.children,
    onConfirm = _ref.onConfirm,
    onClear = _ref.onClear,
    goBack = _ref.goBack,
    selectedDateText = _ref.selectedDateText;
  var _useDevice = useDevice(),
    isMobile = _useDevice.isMobile;
  return /*#__PURE__*/React.createElement(React.Fragment, null, isMobile && /*#__PURE__*/React.createElement(CalendarHeader, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 25,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(HeaderAction, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 26,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(TextLink, {
    onClick: goBack,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 27,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(TextLink.Icon, {
    icon: BackArrowIcon,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 28,
      columnNumber: 15
    }
  })), /*#__PURE__*/React.createElement(TextLink, {
    onClick: onClear,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 30,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(TextLink.Text, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 31,
      columnNumber: 15
    }
  }, "Clear"))), /*#__PURE__*/React.createElement(DaysHeader, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 34,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(WeekDay, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 35,
      columnNumber: 13
    }
  }, "S"), /*#__PURE__*/React.createElement(WeekDay, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 36,
      columnNumber: 13
    }
  }, "M"), /*#__PURE__*/React.createElement(WeekDay, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 37,
      columnNumber: 13
    }
  }, "T"), /*#__PURE__*/React.createElement(WeekDay, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 38,
      columnNumber: 13
    }
  }, "W"), /*#__PURE__*/React.createElement(WeekDay, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 39,
      columnNumber: 13
    }
  }, "T"), /*#__PURE__*/React.createElement(WeekDay, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 40,
      columnNumber: 13
    }
  }, "F"), /*#__PURE__*/React.createElement(WeekDay, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 41,
      columnNumber: 13
    }
  }, "S"))), /*#__PURE__*/React.createElement(CalendarContainer, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 45,
      columnNumber: 7
    }
  }, children), /*#__PURE__*/React.createElement(CalendarActionContainer, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 46,
      columnNumber: 7
    }
  }, !isMobile && /*#__PURE__*/React.createElement(ButtonGroupBigScreen, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 48,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(Button, {
    text: 'Confirm',
    onClick: onConfirm,
    "data-testid": "datePickerActionBtn-Confirm",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 49,
      columnNumber: 13
    }
  }), /*#__PURE__*/React.createElement(ClearButton, {
    onClick: onClear,
    "data-testid": "datePickerActionBtn-Clear",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 54,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(TextLink, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 58,
      columnNumber: 15
    }
  }, "Clear"))), isMobile && /*#__PURE__*/React.createElement(ButtonGroupMobileView, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 63,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(DateText, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 64,
      columnNumber: 13
    }
  }, selectedDateText || 'Select a date'), /*#__PURE__*/React.createElement(Button, {
    text: 'Confirm',
    onClick: onConfirm,
    "data-testid": "datePickerActionBtn-Confirm",
    fullWidth: true,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 65,
      columnNumber: 13
    }
  }))));
};
var CalendarHeader = withTheme(styled.div.withConfig({
  displayName: "DatePickerCalendarContainer__CalendarHeader",
  componentId: "sc-1y3fhke-0"
})(["display:block;position:fixed;z-index:1;top:0;left:0;width:100vw;"]));
var HeaderAction = withTheme(styled.div.withConfig({
  displayName: "DatePickerCalendarContainer__HeaderAction",
  componentId: "sc-1y3fhke-1"
})(["display:flex;justify-content:space-between;align-items:center;height:55px;padding:0 ", "px;"], function (p) {
  return p.coreTheme.space_6;
}));
var DaysHeader = withTheme(styled.div.withConfig({
  displayName: "DatePickerCalendarContainer__DaysHeader",
  componentId: "sc-1y3fhke-2"
})(function (_ref2) {
  var coreTheme = _ref2.coreTheme;
  return css(["background-color:", ";display:flex;align-items:center;padding:", "px ", "px;"], coreTheme.cl_ter_l6, coreTheme.space_4, coreTheme.space_6);
}));
var WeekDay = withTheme(getStyledText('boldBody', {
  lineHeight: 'compact'
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    margin: 0 auto;\n    color: ", ";\n    font-size: ", ";\n  "])), function (p) {
  return p.coreTheme.cl_sec_d2;
}, function (p) {
  return p.coreTheme.fs_sm;
}));
var CalendarContainer = withTheme(styled.div.withConfig({
  displayName: "DatePickerCalendarContainer__CalendarContainer",
  componentId: "sc-1y3fhke-3"
})(["margin-top:110px;height:calc(100vh - 230px);overflow:auto;", ""], Config.media.sm(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    margin-top: unset;\n    height: unset;\n    overflow: unset;\n  "])))));
var CalendarActionContainer = withTheme(styled.div.withConfig({
  displayName: "DatePickerCalendarContainer__CalendarActionContainer",
  componentId: "sc-1y3fhke-4"
})(function (_ref3) {
  var coreTheme = _ref3.coreTheme;
  return css(["position:fixed;z-index:1;bottom:0;left:0;width:100vw;box-shadow:17px 2px 12px rgba(0,0,0,0.14);", ""], Config.media.sm(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n        border-top: 1px solid ", ";\n        position: unset;\n        width: unset;\n        box-shadow: unset;\n      "])), coreTheme.cl_ter_l4));
}));
var ClearButton = withTheme(styled.div.withConfig({
  displayName: "DatePickerCalendarContainer__ClearButton",
  componentId: "sc-1y3fhke-5"
})(["", ""], function (_ref4) {
  var coreTheme = _ref4.coreTheme;
  return css(["padding:", "px ", "px;margin-right:", "px;display:flex;align-items:center;"], coreTheme.space_2, coreTheme.space_5, coreTheme.space_5);
}));
var ButtonGroupBigScreen = withTheme(styled.div.withConfig({
  displayName: "DatePickerCalendarContainer__ButtonGroupBigScreen",
  componentId: "sc-1y3fhke-6"
})(["display:flex;flex-direction:row-reverse;padding:", "px;"], function (p) {
  return p.coreTheme.space_4;
}));
var ButtonGroupMobileView = withTheme(styled.div.withConfig({
  displayName: "DatePickerCalendarContainer__ButtonGroupMobileView",
  componentId: "sc-1y3fhke-7"
})(function (_ref5) {
  var coreTheme = _ref5.coreTheme;
  return css(["height:120px;box-sizing:border-box;padding:", "px ", "px ", "px;background-color:", ";"], coreTheme.space_4, coreTheme.space_6, coreTheme.space_8, coreTheme.cl_white);
}));
var DateText = withTheme(getStyledText('body', {
  lineHeight: 'compact'
})(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  margin-bottom: ", "px;\n"])), function (p) {
  return p.coreTheme.space_2;
}));
DatePickerCalendarContainer.defaultProps = {
  onConfirm: noop,
  onClear: noop,
  goBack: noop
};
export default DatePickerCalendarContainer;